import { PropsWithChildren } from 'react';

import ChannelProvider from '@/channels/ChannelProvider';
import { generatedDocumentsChannelName } from '@/channels/utils/channelNames';

import { Props } from './types';

const GeneratedDocumentsChannel = ({ children, personId }: PropsWithChildren<Props>) => {
  return (
    <ChannelProvider channelName={generatedDocumentsChannelName(personId)}>
      {children}
    </ChannelProvider>
  );
};

export default GeneratedDocumentsChannel;
